import { AgreementRest } from "./agreeementApi.model"
import { Agreement } from "../../model/agreement/agreement"

export const toAgreement = (src: AgreementRest): Agreement => ({
    id: src.id,
    acceptedAt: src.accepted_at ?? undefined,
})
